module.exports = __webpack_public_path__ + "img/b5_p_m.d634f83e.png";